// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import RequestOverviewGroupItem from "./types/RequestOverviewGroupItem";
// @ts-ignore - not used import
import SignRequestOverviewFilterVO from "./types/SignRequestOverviewFilterVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 * Service pro přehledy Generated from cz.marbes.qsign.controller.QSignPrehledController.
 */
export default class QSignPrehledApi {
    /**
     * 
     *
     * @param filterVO 
     */
    static exportReport(filterVO : SignRequestOverviewFilterVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignPrehledApi.raw.exportReport(filterVO, config));
    }
    /**
     * Najde přehled dokumentů zagurpovaný za datum změny (exectuion_change)
     *
     * @param filterVO filter
     * @return seznam skupin
     */
    static findOverview(filterVO : SignRequestOverviewFilterVO, config?: {cancelToken?: CancelToken}) : Promise<RequestOverviewGroupItem[]> {
        return unwrapResponse<RequestOverviewGroupItem[]>(QSignPrehledApi.raw.findOverview(filterVO, config));
    }

    static raw = {
            exportReport: function(filterVO : SignRequestOverviewFilterVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/overview/export`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, filterVO, finalConfig);
            },
            findOverview: function(filterVO : SignRequestOverviewFilterVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<RequestOverviewGroupItem[]>> {
                const uri = `/qsign/api/overview/`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<RequestOverviewGroupItem[]>>(finalUri, filterVO, finalConfig);
            },
    }
}
